<div class="tw-text-neutral-800 tw-text-lg md:tw-text-2xl">
  <ng-content></ng-content>
</div>
